import { render, staticRenderFns } from "./BibleCloudBookSelector.vue?vue&type=template&id=0e63bd56&scoped=true&"
import script from "./BibleCloudBookSelector.vue?vue&type=script&lang=js&"
export * from "./BibleCloudBookSelector.vue?vue&type=script&lang=js&"
import style0 from "./BibleCloudBookSelector.vue?vue&type=style&index=0&id=0e63bd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63bd56",
  null
  
)

export default component.exports